import User from 'shared/storage/user';
import SessionStorage from 'client/javascript/storage/session_storage';

const virtualTourKey = slug => `virtual-tour:${slug}`;
export const setVirtualTour = (slug, date = Date.now()) => {
  const key = virtualTourKey(slug);
  return SessionStorage.setItem(key, date);
};
export const getVirtualTour = slug => {
  const key = virtualTourKey(slug);
  return SessionStorage.getItem(key);
};

export const LOCATION_ID = 'location_id';
export const getLocationId = () => User.getValue(LOCATION_ID);
export const setLocationId = locationId => User.saveValue(LOCATION_ID, locationId);

export const DESIRED_CAPACITY = 'desired_capacity';
export const getDesiredCapacity = () => User.getValue(DESIRED_CAPACITY);
export const setDesiredCapacity = count => User.saveValue(DESIRED_CAPACITY, count);
